document.addEventListener("DOMContentLoaded", () => {
	const passwordGroup = document.querySelector(".form-login #login_password")?.closest(".form-group");
	if (!passwordGroup || !window.login) return;

	passwordGroup.insertAdjacentHTML(
		"afterend",
		`<div class="form-group">
			<label class="form-label" for="login_captcha">Enter the characters shown</label>
			<div style="display:flex;gap:8px;align-items:center;margin-bottom:6px">
				<img id="login_captcha_img" alt="CAPTCHA" style="border:1px solid var(--border-color);border-radius:6px">
				<a href="#" id="login_captcha_refresh">Refresh</a>
			</div>
			<input type="text" id="login_captcha" class="form-control" autocomplete="off" required>
		</div>`
	);

	let captchaId = null;
	let publicKey = null;
	const refresh = () =>
		frappe.call({ method: "mahasamund_hrms.api.captcha.get_login_captcha" }).then((r) => {
			captchaId = r.message.id;
			publicKey = r.message.public_key;
			document.getElementById("login_captcha_img").src = r.message.image;
			document.getElementById("login_captcha").value = "";
		});

	document.getElementById("login_captcha_refresh").addEventListener("click", (e) => {
		e.preventDefault();
		refresh();
	});
	refresh();

	// Send the CAPTCHA and the encrypted password, then fetch a new CAPTCHA (each is single-use).
	const originalCall = login.call;
	login.call = async function (args, ...rest) {
		if (args.cmd !== "login" || !args.pwd) return originalCall.call(this, args, ...rest);

		args.captcha_id = captchaId;
		args.captcha = document.getElementById("login_captcha").value;
		args.pwd = await mahasamund_encrypt(publicKey, `${captchaId}:${args.pwd}`); // bound to this one-time CAPTCHA
		const request = originalCall.call(this, args, ...rest);
		Promise.resolve(request).finally(refresh);
		return request;
	};
});
